<template>
	<div class="myChart1"></div>
</template>

<script>
import { EleResize } from '@/utils/EleResize';
import * as echarts from 'echarts';
export default {
	name: 'barCharts',
	props: {
		chartData: {
			type: Array,
			default: []
		}
	},
	data() {
		return {
			echart1: null
		};
	},
	mounted() {
		// this.ChartOne()
	},
	watch: {
		chartData: {
			handler(newVal, oldVal) {
				if (newVal && newVal.length > 0) {
					const Xdata = newVal.map(item => item.date);
					const data = newVal.map(item => item.count);
					this.$nextTick(() => {
						this.ChartOne(Xdata, data);
					});
				}
			},
			immediate: true,
			deep: true
		}
	},
	methods: {
		ChartOne(Xdata, data) {
			this.echart1 = this.$echarts.init(document.querySelector('.myChart1'));
			let dom = document.querySelector('.myChart1');
			var map4_data1 = [12, 14, 10, 20, 6];
			// var map4_data2 = [this.completedNum[0], this.completedNum[1], this.completedNum[2], this.completedNum[3], this.completedNum[4], this.completedNum[5], this.completedNum[6]];
			if (dom) {
				EleResize.on(dom, this.echart1.resize);
				this.echart1.setOption({
					color: ['#90B5FF', '#3BD77E', '#FFD300'],

					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						}
					},
					grid: {
						top: '10',
						left: '5',
						right: '0',
						bottom: '10',
						containLabel: true
					},
					calculable: true,
					xAxis: [
						{
							type: 'category',
							axisTick: { show: false },
							data: Xdata,
							axisLabel: {
								show: true,
								color: '#F4FAFF',
								fontSize: 11,
								interval: 0,
								align: 'center',
								formatter: function (value, index) {
								    return value.slice(8,10);
								}
							},
							axisLine: {
								//不显示坐标轴线
								show: true,
								lineStyle: {
									color: '#2F5A8D'
								}
							},
							axisTick: {
								show: false,
								alignWithLabel: true,
								lineStyle: {
									color: '#fff',
									type: 'solid' //线的类型。'solid' 'dashed' 'dotted'
								}
							}
						}
					],
					yAxis: [
						{
							type: 'value',
							splitLine: {
								//网格线
								lineStyle: {
									type: 'dashed', //设置网格线类型 dotted：虚线 solid:实线
									color: 'rgba(255,255,255,0.149)'
								}
								// show: true //隐藏或显示
							},
							axisLabel: {
								show: true,
								color: '#F4FAFF',
								fontSize: 12
							}
						}
					],
					series: [
						{
							name: '数量',
							type: 'bar',
							barWidth: 14,
							data: data,
							itemStyle: {
								barBorderRadius: [30, 30, 0, 0],

								// color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{ offset: 0, color: '#22B2FB' }, { offset: 1, color: '#2F5A8D' }])
								color: params => {
									let colors = [
										new echarts.graphic.LinearGradient(0, 0, 0, 1, [
											{
												offset: 0,
												color: '#22B2FB'
											},
											{
												offset: 1,
												color: '#2F5A8D'
											}
										]),
										new echarts.graphic.LinearGradient(0, 0, 0, 1, [
											{
												offset: 0,
												color: '#17E5DE'
											},
											{
												offset: 1,
												color: '#2F5A8D'
											}
										]),
										new echarts.graphic.LinearGradient(0, 0, 0, 1, [
											{
												offset: 0,
												color: '#E56E17'
											},
											{
												offset: 1,
												color: '#2F5A8D'
											}
										])
									];
									return colors[params.dataIndex] || colors[0];
								}
							},
							emphasis: {
								itemStyle: {
									color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{ offset: 0, color: '#22B2FB' }, { offset: 1, color: '#2F5A8D' }])
								}
							}
						}
					]
				});
			}
		}
	}
};
</script>

<style scoped lang="scss">
.myChart1 {
	height: 200px;
}
</style>
